import { AxiosError } from 'axios';
import { ApiError } from './types';

export interface NormalizedError {
    message: string;
    status?: number;
    code?: string;
    raw: unknown;
}

const FALLBACK_MESSAGE = 'Server error. Please try again after sometime.';

export function normalizeError(error: unknown): NormalizedError {
    const ax = error as AxiosError<any>;

    if (ax?.isAxiosError) {
        if (ax.response) {
            const data = ax.response.data;
            return {
                message:
                    data?.error ||
                    data?.message ||
                    ax.message ||
                    'Request failed',
                status: ax.response.status,
                code: data?.code,
                raw: error
            };
        }
        return { message: FALLBACK_MESSAGE, raw: error };
    }

    if (error instanceof Error) {
        return { message: error.message, raw: error };
    }

    return { message: 'Unknown error', raw: error };
}

export function toApiErrorResult(error: unknown): ApiError {
    const n = normalizeError(error);
    return {
        type: n.status ? 'error' : 'failed',
        response: {
            message: n.message,
            status: n.status,
            code: n.code
        }
    };
}
